import type { GameManifest } from '@adgf/shared';
import { GameStatus } from '@adgf/shared';

const manifest: GameManifest = {
  id: 'a7b8c9d0-e1f2-4a3b-8c9d-0e1f2a3b4c5d',
  slug: 'match-3',
  title: 'Gem Match',
  description: 'Swap adjacent gems to match 3 or more. Chain combos for big scores! 60-second time limit.',
  version: '0.1.0',
  template_id: 'match3',
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'medium',
  duration: 60,
  features: ['match-3', 'combo', 'timed', 'swap'],
  entrypoint: 'phaser:match-3',
  analytics_schema: {
    events: ['game_open', 'game_start', 'gem_swap', 'match_3', 'match_4', 'match_5', 'combo', 'game_over'],
  },
};

export default manifest;
